if (document.documentElement.clientWidth > 768 && document.querySelector('.lazy-load-video')) {
	var $backgroundVideo = document.querySelector('.lazy-load-video'),
		sourceTag = document.createElement('source'),
		videoSrc = $backgroundVideo.dataset.video;

	sourceTag.setAttribute('src', videoSrc);
	sourceTag.type = 'video/mp4';

	$backgroundVideo.appendChild(sourceTag);
}	
	
	//if multiple videos
	var lazyVideos = [].slice.call(document.querySelectorAll(".lazy-load-videos"));

	//if scrolled into view
	if ("IntersectionObserver" in window) {
		var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
		  entries.forEach(function(video) {
			if (video.isIntersecting) {
			  for (var source in video.target.children) {
				var videoSource = video.target.children[source];
				if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
				  videoSource.src = videoSource.dataset.src;
				}
			  }
	
			  video.target.load();
			  video.target.classList.remove("lazy");
			  lazyVideoObserver.unobserve(video.target);
			}
		  });
		});
	
		lazyVideos.forEach(function(lazyVideo) {
		  lazyVideoObserver.observe(lazyVideo);
		});
	} 